/**
 * El copy de la propuesta de sección (GKTIBO-147). Aparte, por D4: `textos.ts`
 * ya pasó de 300 líneas.
 */
export const propuesta = {
  pregunta: (cuantas: number, titulo: string) =>
    `Tenés ${cuantas} cosas sobre ${titulo.toLowerCase()}. ¿Las agrupo en una sección «${titulo}»?`,
  si: 'Sí, agrupalas',
  no: 'No, dejalas como están',
  agrupadas: (titulo: string) => `Listo: ahora tu bot tiene una sección «${titulo}».`,
  noSePudo: 'No pudimos hacerlo ahora. Probá de nuevo más tarde.',
  yaCambiaron: 'Esas cosas ya cambiaron. Te muestro lo que hay ahora.',
} as const;
